/** @jsx jsx */
import { jsx } from 'theme-ui';
import Image from 'gatsby-image';
import cssOverlay from '../../helpers/cssOverlay';

export default function ListRowBackgroundImage(props) {
  return (
    <Image
      {...props}
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        transition: 'transform 0.7s ease-out',
        '::after': {
          ...cssOverlay(),
          transition: 'background 0.3s ease-out',
        },
      }}
      style={{ position: null, width: null, height: null }}
      placeholderStyle={{ filter: 'blur(5px)' }}
    />
  );
}
